document.addEventListener('DOMContentLoaded', () => {

  // Header scroll
  const hdr = document.getElementById('site-header');
  if(hdr){
    const ban=document.querySelector('.urgency-banner');
    const place=()=>{hdr.classList.toggle('scrolled', scrollY > 50);hdr.style.top=ban?Math.max(0,ban.getBoundingClientRect().bottom)+'px':'0px'};  // sit just under the green banner until it scrolls away
    window.addEventListener('scroll',place,{passive:true});window.addEventListener('resize',place);place();
  }

  // Hamburger
  const ham = document.getElementById('hamburger');
  const mNav = document.getElementById('mobile-nav');
  if(ham && mNav) ham.addEventListener('click', () => {
    ham.classList.toggle('open');
    mNav.classList.toggle('open');
  });

  // Reveal on scroll
  const revealEls = document.querySelectorAll('.reveal');
  if(revealEls.length) {
    new IntersectionObserver((entries) => {
      entries.forEach(e => { if(e.isIntersecting) e.target.classList.add('in'); });
    }, {threshold: 0.08}).observe
    ? new IntersectionObserver((e) => e.forEach(el => { if(el.isIntersecting) el.target.classList.add('in'); }), {threshold: 0.08})
      .observe && revealEls.forEach(el => {
        new IntersectionObserver((entries) => { entries.forEach(e => { if(e.isIntersecting) e.target.classList.add('in'); }); }, {threshold: 0.08}).observe(el);
      })
    : null;
  }
  // Simpler version
  const ro = new IntersectionObserver(entries => entries.forEach(e => { if(e.isIntersecting){e.target.classList.add('in'); ro.unobserve(e.target);} }), {threshold:0.08});
  document.querySelectorAll('.reveal').forEach(el => ro.observe(el));

  // Stat counters
  const counters = document.querySelectorAll('[data-count]');
  const cr = new IntersectionObserver(entries => entries.forEach(e => {
    if(!e.isIntersecting) return;
    const el = e.target, target = +el.dataset.count, suffix = el.dataset.suffix||'';
    let cur = 0; const step = target/60;
    const t = setInterval(() => { cur = Math.min(cur+step, target); el.textContent = Math.floor(cur).toLocaleString()+suffix; if(cur>=target) clearInterval(t); }, 16);
    cr.unobserve(el);
  }), {threshold:0.5});
  counters.forEach(c => cr.observe(c));

  // FAQ accordion
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item.open').forEach(i => i.classList.remove('open'));
      if(!isOpen) item.classList.add('open');
    });
  });

  // Variant buttons
  document.querySelectorAll('.var-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.closest('.variants').querySelectorAll('.var-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const priceEl = document.querySelector('#price-display');
      if(priceEl && btn.dataset.price) priceEl.textContent = btn.dataset.price;
    });
  });

  // Gallery thumbnails
  document.querySelectorAll('.thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const mainImg = document.querySelector('.gallery-main img');
      if(mainImg) mainImg.src = thumb.querySelector('img').src.replace('200x200','800x800');
      document.querySelectorAll('.thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // Drop zone
  const dropZone = document.querySelector('.drop-zone');
  const fileInput = document.querySelector('#photo-upload');
  const fileChosen = document.querySelector('.file-chosen');
  if(dropZone && fileInput) {
    dropZone.addEventListener('click', () => fileInput.click());
    dropZone.addEventListener('dragover', e => { e.preventDefault(); dropZone.style.borderColor='var(--green)'; dropZone.style.background='var(--green-dim)'; });
    dropZone.addEventListener('dragleave', () => { dropZone.style.borderColor=''; dropZone.style.background=''; });
    dropZone.addEventListener('drop', e => {
      e.preventDefault(); dropZone.style.borderColor=''; dropZone.style.background='';
      if(e.dataTransfer.files.length && fileChosen) {
        fileChosen.style.display='block';
        fileChosen.textContent = '✓ '+Array.from(e.dataTransfer.files).map(f=>f.name).join(', ');
      }
    });
    fileInput.addEventListener('change', () => {
      if(fileInput.files.length && fileChosen) {
        fileChosen.style.display='block';
        fileChosen.textContent = '✓ '+Array.from(fileInput.files).map(f=>f.name).join(', ');
      }
    });
  }

});
